/**
 * Food-collection persistence schema.
 *
 * Invariants:
 * - Default user collections must be private and unique per user.
 */
import { check, foreignKey, pgEnum, pgTable, text, unique, uuid } from "drizzle-orm/pg-core";
import { relations, sql } from "drizzle-orm";
import { id } from "../../utils/sql";
import { user } from "../../auth/core/user.sql";
import { scope } from "../../auth/scope/scope.sql";
import { visibility } from "../../common/utils.sql";
import { foodMeta } from "../food/food.sql";
import { foodType } from "../food/food-type.sql";
import { foodCollectionTypes } from "./constants";

export const foodCollectionType = pgEnum("food_collection_type", foodCollectionTypes);

export const foodCollection = pgTable(
  "food_collection",
  {
    ...id,
    scopeId: uuid("scope_id")
      .notNull()
      .references(() => scope.id),
    type: foodCollectionType("type").notNull(),
    allowedFoodTypes: foodType("food_types").array(),
    name: text("name").notNull(),
    visibility: visibility("visibility").notNull(),
    defaultForUserId: uuid("default_for_user_id")
      .references(() => user.id)
      .unique(),
  },
  (t) => [
    unique("food_collection_scope_id_unique").on(t.scopeId, t.id),
    check(
      "food_collection_default_for_user",
      sql`${t.defaultForUserId} IS NULL OR (${t.type} = 'user' AND ${t.visibility} = 'private')`,
    ),
    foreignKey({
      name: "food_collection_scope_id_fk",
      columns: [t.scopeId],
      foreignColumns: [scope.id],
    }),
  ],
);

export const foodCollectionRelations = relations(foodCollection, ({ many, one }) => ({
  foodMetas: many(foodMeta),
  scope: one(scope, {
    fields: [foodCollection.scopeId],
    references: [scope.id],
  }),
}));
